<template>
        <el-drawer title="编辑权重" :visible.sync="updateVisible" :before-close="closeDialog" size="400px">
            <div class="drawer-content">
                <el-form :model="form" label-position="top" ref="updateForm" :rules="rules">                 
                                          
                    <el-form-item label="排序因子" prop="keyView">
                        <el-input v-model="form.keyView" autocomplete="off" maxlength="40" placeholder="请输入排序因子" size="medium" disabled></el-input>
                    </el-form-item> 
					<el-form-item label="权重百分比" prop="weight">
					    <el-input-number v-model="form.weight" :min="1" :max="2000" label="请输入权重百分比" controls-position="right" style="width: 90%;"></el-input-number> %
					    <div class="color-danger">
					    	(权重百分比输入范围在1%-2000%)
					    </div>
					</el-form-item>                    
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
            </div>
        </el-drawer>
</template>

<script>
const defaultData = {   
    keyView: '', // 关键字名称
    weight: '', // 排序
}
export default {
    props: {
    },
    data(){
       
        return {
            form: {...defaultData},           
            submitLoading: false,            
            rules: {               
                keyView:  [
                    { required: true, message: '请输入排序因子', trigger: 'blur' }
                ],
				weight:  [
				    { required: true, message: '请输入权重百分比', trigger: 'blur' }
				]  
            },
            updateVisible: false
        }
    },
    created(){
        
    },
    
    methods: {
        show(data){
            if( data ){
                const n = {...data};               
                this.form = {...n};
            }
            
            this.updateVisible = true;
        },
        submitForm(){
			
            this.$refs['updateForm'].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                          
                    this.$request({
                        url:'/weight/act/save',
                        method: "POST",
                        data: {...this.form},
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('修改成功');
							this.$emit('onUpdate');
                            this.closeDialog();
                            
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            });
        },
       
        closeDialog(){           
            this.form = {...defaultData};            
            this.updateVisible = false;            
        }
    }
}
</script>

<style lang="scss" scoped>
.terminal{
    ::v-deep .el-form-item__content{
        line-height: 34px;
    }
}
.has-tips {
    ::v-deep .el-form-item__label{
        width: 100%;
        display: flex;
        align-items: center;

        & > * {
            flex: 0 0 auto;
        }
        .tips{
            flex: 1 1 auto;
            margin-left: 10px;
            font-size: 12px;
            overflow: hidden;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }    
}
</style>